export const fallback = (source = '�') => ({
    type: 'fallback',
    source,
    toParts: () => [{ type: 'fallback', source }],
    toString: () => `{${source}}`
});
